var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsscher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 73.765 62.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.952 48.72 18.793 57.958 53.327 57.958 47.168 48.72 24.952 48.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "9.26 13.892 9.26 48.425 18.498 42.266 18.498 20.051 9.26 13.892"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.042 48.283 21.488 45.73 18.935 43.176 9.545 49.436 17.781 57.673 24.042 48.283"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.168 13.595 53.326 4.358 18.795 4.358 24.953 13.595 47.168 13.595"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.079 14.031 50.633 16.586 53.187 19.139 62.576 12.88 54.338 4.642 48.079 14.031"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "21.488 16.586 24.042 14.031 17.782 4.642 9.544 12.88 18.934 19.14 21.488 16.586"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.633 45.73 48.079 48.284 54.339 57.673 62.576 49.436 53.186 43.176 50.633 45.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.623 42.266 62.86 48.424 62.86 13.892 53.623 20.05 53.623 42.266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.714,12.6l-9.1-9.1-.353-.146h-36.4l-.353.146-9.1,9.1-.146.353v36.4l.146.354,9.1,9.1.353.147h36.4l.353-.147,9.1-9.1.146-.354v-36.4Zm-.854,35.82-9.237-6.158V20.05l9.237-6.158Zm-53.6,0V13.892L18.5,20.051V42.266ZM52.623,41.6v.726l-.285.286-4.825,4.824-.284.285H24.893l-.286-.285L19.783,42.61l-.285-.285V19.99l.285-.285,4.825-4.825.285-.285H47.229l.284.285L52.338,19.7l.285.285V41.6Zm.564-22.46-2.554-2.553-2.554-2.555,6.259-9.389,8.238,8.238Zm.139-14.781L47.168,13.6H24.953L18.8,4.358Zm-35.544.284,6.26,9.389-2.554,2.555L18.934,19.14l-9.39-6.26Zm1.153,38.534,2.553,2.554,2.554,2.553-6.261,9.39L9.545,49.436Zm-.142,14.782,6.159-9.238H47.168l6.159,9.238Zm35.546-.285-6.26-9.389,2.554-2.554,2.553-2.554,9.39,6.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "52.338 19.705 47.513 14.88 47.229 14.595 46.501 14.595 25.62 14.595 24.893 14.595 24.608 14.88 19.783 19.705 19.498 19.99 19.498 20.717 19.498 41.599 19.498 42.325 19.783 42.61 24.607 47.435 24.893 47.72 25.619 47.72 46.501 47.72 47.229 47.72 47.513 47.435 52.338 42.611 52.623 42.325 52.623 41.599 52.623 20.717 52.623 19.99 52.338 19.705"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsscher);
export default __webpack_public_path__ + "static/media/asscher.f5cc0cd225999962a9f43d81cd3792b6.svg";
export { ForwardRef as ReactComponent };